import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faComments } from "@fortawesome/free-solid-svg-icons"

export const Comments = (props) => {
  return <FontAwesomeIcon faIcon={faComments} {...props} />
}
